import styled from "@emotion/styled";
import { colors, ListItem, VStack } from "goi_common";

export default function InfoSection({
  type,
  infoDescriptionItems,
}: {
  type?: string;
  infoDescriptionItems: string[];
}) {
  return (
    <VStack padding="40px 0px 40px" gap={12} background="white">
      <VStack gap={12}>
        <VStack
          padding="20px 24px"
          background={colors.gray100}
          className="subtitle2_sb gray700"
          borderRadius={10}
        >
          [고이 PRIME] 주요정보 안내사항
        </VStack>

        <Content>
          <VStack as="ul" gap={10}>
            {infoDescriptionItems.map((item) => (
              <Description
                className="body3_r gray600"
                key={item}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            ))}
          </VStack>
        </Content>
      </VStack>
    </VStack>
  );
}

const Content = styled(VStack)`
  padding: 28px 28px 28px 16px;
  background: var(--gray50);
  border-radius: 10px;
  margin-top: 12px;
`;

const Description = styled(ListItem)`
  text-indent: -12px;
  margin-left: 12px;
  white-space: pre-linke;
`;
